/* VORA Landingpage – Interaktionen (Mythen, Ziele, Pakete, Abo, Warenkorb) */
(function () {
  if (window.__voraInit) return;
  window.__voraInit = true;

  document.addEventListener('click', function (e) {
    // Mythen umdrehen
    var myth = e.target.closest('.vora .myth');
    if (myth) {
      myth.classList.toggle('open');
      myth.setAttribute('aria-pressed', myth.classList.contains('open'));
      return;
    }
    // Ziel-Auswahl
    var goal = e.target.closest('.vora .goal');
    if (goal) {
      var root = goal.closest('.vora');
      root.querySelectorAll('.goal').forEach(function (b) { b.classList.remove('on'); b.setAttribute('aria-pressed', 'false'); });
      root.querySelectorAll('.goalpanel').forEach(function (p) { p.classList.remove('on'); });
      goal.classList.add('on'); goal.setAttribute('aria-pressed', 'true');
      var panel = root.querySelector('.goalpanel[data-goal="' + goal.dataset.goal + '"]');
      if (panel) panel.classList.add('on');
      return;
    }
    // Abo-Schalter
    var sw = e.target.closest('.vora .switch');
    if (sw) {
      var on = sw.getAttribute('aria-checked') !== 'true';
      sw.setAttribute('aria-checked', on);
      var offer = sw.closest('.vora');
      offer.classList.toggle('is-abo', on);
      updateSticky(offer);
      return;
    }
    // Kaufen-Button
    var buy = e.target.closest('.vora [data-buy]');
    if (buy) {
      e.preventDefault();
      var card = buy.closest('.pc');
      addToCart(card, buy);
      return;
    }
    // Paket auswählen
    var pc = e.target.closest('.vora .pc');
    if (pc) selectPack(pc);
  });

  document.addEventListener('keydown', function (e) {
    if ((e.key === 'Enter' || e.key === ' ') && e.target.classList && e.target.classList.contains('pc')) {
      e.preventDefault(); selectPack(e.target);
    }
  });

  function selectPack(pc) {
    var wrap = pc.closest('.vora');
    wrap.querySelectorAll('.pc').forEach(function (c) { c.classList.remove('on'); c.setAttribute('aria-checked', 'false'); });
    pc.classList.add('on'); pc.setAttribute('aria-checked', 'true');
    updateSticky(wrap);
  }

  function updateSticky(wrap) {
    var bar = document.querySelector('.vora-sticky');
    var pc = wrap.querySelector('.pc.on');
    if (!bar || !pc) return;
    var abo = wrap.classList.contains('is-abo');
    bar.querySelector('[data-s-name]').textContent = pc.dataset.name;
    bar.querySelector('[data-s-price]').textContent = abo ? pc.dataset.aboPrice + ' im Abo' : pc.dataset.price;
  }

  function addToCart(card, btn) {
    var wrap = card.closest('.vora');
    var abo = wrap.classList.contains('is-abo');
    var id = card.dataset.variant;
    if (!id) { alert('Bitte im Theme-Editor in der Preis-Section ein Produkt auswählen.'); return; }
    var item = { id: Number(id), quantity: Number(card.dataset.qty || 1) };
    if (abo && card.dataset.plan) item.selling_plan = Number(card.dataset.plan);
    var label = btn.textContent;
    btn.textContent = 'Wird hinzugefügt …';
    fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [item] })
    }).then(function (r) {
      if (!r.ok) throw new Error('cart');
      window.location.href = card.dataset.goto || '/checkout';
    }).catch(function () {
      btn.textContent = label;
      alert('Das hat nicht geklappt. Bitte versuch es noch einmal.');
    });
  }
})();
